import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  slot: "logo",
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_2 = {
  slot: "title",
  class: "center title-2"
}
const _hoisted_3 = {
  slot: "form",
  class: "reset-password-form"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "submit" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  slot: "links",
  class: "link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_locale_select = _resolveComponent("base-locale-select")!

  return (_openBlock(), _createElementBlock("dig-ui-login-card", null, [
    _hoisted_1,
    _createElementVNode("dig-ui-title", _hoisted_2, _toDisplayString(_ctx.$t('chooseNewPassword')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("dig-input-password", {
        value: _ctx.password,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.password = $event.target.value)),
        required: "",
        id: "password",
        name: "password",
        ref: "passwordEl"
      }, _toDisplayString(_ctx.$t('User.password')), 41, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("dig-ui-standard-button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetPassword()))
            }, _toDisplayString(_ctx.$t('validate')), 1))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("dig-ui-loader", _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_locale_select)
      ])
    ])
  ]))
}